export const logData = (key, value) => {
    console.log(key, value);
};
